import { agentCard, applyOverrides } from '../../shared';

export const buyersAgentCard = applyOverrides(agentCard, {
  id: 'buySideContacts.buyersAgent',
  innerTitle: "Buyer's Agent x",
  outerTitle: "Buyer's Agents",
  addableTitle: "Buyer's Agent x",
  addText: "Buyer's Agent",
  fields: {
    firstName: {
      validation: () => [],
    },
    lastName: {
      validation: () => [],
    },
    email: {
      validation: () => [
        {
          type: 'email',
          message: 'Invalid Email',
        },
      ],
    },
  },
});
